// App.tsx
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import Credenciamento from './pages/Credenciamento'
import LoginPage from './pages/Login'
import PrintEtiqueta from './pages/PrintEtiqueta'

const App: React.FC = () => {
  return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/credenciamento"
          element={
            <ProtectedRoute>
              <Credenciamento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/impressao"
          element={
            <ProtectedRoute>
              <PrintEtiqueta />
            </ProtectedRoute>
          }
        />
      </Routes>
  );
};

export default App;
